module.exports = __webpack_public_path__ + "SourceSansPro-Bold.a50200ff088b3477b9fb.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Bold.eot
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Bold.eot
// module chunks = styles